<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="actualizado()">
        <div class="card">
            <div v-if="!entrada.butaca && !entrada.numero" class="card-header bg-secondary">
                {{ entrada.asiento.zona_nombre ?? entrada.zona_nombre }} <br>
                <span v-if="entrada.asiento.fila && entrada.asiento.asiento">Fila: {{ entrada.asiento.fila }} / Butaca: {{ entrada.asiento.asiento }}</span>
                <span v-else>Sin numerar</span>
            </div>
            <div v-else-if="entrada.butaca" class="card-header bg-secondary">
                <span>Sector: {{ entrada.nombre_sector ?? entrada.sector_name }}</span> <br>
                <span>Fila: {{ entrada.fila }} / Butaca: {{ entrada.butaca }}</span>
            </div>
            <div v-else-if="entrada.numero" class="card-header bg-secondary">
                <span>Plaza: {{ entrada.numero }}</span>
            </div>
            <div class="card-body">
                <template v-if="solicitar_datos">
                    <FormInput id="nombre" label="Nombre" name="Nombre" v-model="entrada.nombre" @change="actualizado" />
                    <FormInput id="apellidos" label="Apellidos" name="Apellidos" v-model="entrada.apellidos" @change="actualizado" />
                    <FormInput id="dni" label="DNI" name="DNI" v-model="entrada.dni" @change="actualizado" />
                </template>
                
                <div class="form-group">
                    <label for="precio">Precio</label>
                    <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                        <select class="form-control" id="select-precio" v-model="entrada.precio" v-on:change="actualizado">
                            <template v-for="(precio, index) in entrada.precios">
                                <option v-if="!entrada.butaca && !entrada.numero" :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                                <option v-else :key="index" :value="precio">{{ precio.description ?? precio.descripcion }} / {{ getPrecio(precio) | formatear_precio }}</option>
                            </template>
                        </select>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="width: 98%; display: block; background-color: red; color: white; padding: 2px;">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
                <div class="form-group">
                    <label for="genero">Género</label>
                    <select class="form-control" id="select-genero" v-model="entrada.genero_id" v-on:change="actualizado">
                        <template v-for="genero in generos">
                            <option :key="genero.id" :value="genero.id">{{ genero.name }}</option>
                        </template>
                    </select>
                </div>
                <div class="form-group" v-if="permisos['venta.descuento']">
                    <label for="descuento">Descuento</label>
                    <select v-model="entrada.descuento" class="form-control" id="select-descuento" v-on:change="actualizado">
                        <option value="0">Sin descuento</option>
                        <template v-for="(descuento, index) in configuracion.descuentos_disponibles">
                            <option :key="index" :value="descuento">{{ descuento }}%</option>
                        </template>
                    </select>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
export default {
    props: ['entrada', 'generos', 'index', 'solicitar_datos'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        }
    },
    methods: {
        actualizado() {
            this.$emit('actualizado');
        },
        getPrecio(precio) {
            let price = parseFloat(precio.precio);
            
            if(precio.price_management_interno_taquilla || precio.gd_interno) {
                return price;
            }

            return price + parseFloat(precio.price_management_taquilla);
        }
    },
}
</script>
